import { render, staticRenderFns } from "./PostsGuideButton.vue?vue&type=template&id=07b129ce&"
import script from "./PostsGuideButton.vue?vue&type=script&lang=js&"
export * from "./PostsGuideButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports